import { useEffect, useRef } from 'react';
import { initP5Drawings } from '../scripts/p5js-drawings.js';

export default function ProjectP5Drawings() {
    const containerRef = useRef(null);

    useEffect(() => {
        let cleanup = null;

        // Si la div existe, on lance le script p5 dedans
        if (containerRef.current) {
            cleanup = initP5Drawings(containerRef.current);
        }

        // On nettoie quand on quitte la page
        return () => {
            if (cleanup) cleanup();
        };
    }, []);

    return (
        <div className="project-page">
            <main className="project-main">
                <div ref={containerRef} id="p5-canvas"></div>

                <div className="project-content">
                    <h1>Sillage Dessiné – Galerie interactive en p5.js</h1>
                    <p className="project-desc">
                        Je cherchais une manière plus ludique de présenter mes dessins 
                        personnels qu'une simple grille d'images. Ici, mes illustrations 
                        se dévoilent et suivent le mouvement de la souris sur le canvas. 
                        Pour que l'animation reste fluide et l'écran lisible, le script 
                        ne garde que les 10 dernières images affichées, qui finissent 
                        par s'effacer progressivement.
                    </p>

                    <div className="project-tech">
                        <h3>Techno</h3>
                        <ul>
                            <li>p5.js</li>
                            <li>Gestion d'une file d'attente (Array) bridée à 10 éléments maximum</li>
                            <li>Chargement multiple d’images avec preload()</li>
                            <li>Logique d'apparition au mouvement et d'effacement progressif</li>
                            <li>Seuil de distance pour créer la traînée</li>
                        </ul>
                    </div>
                </div>
            </main>
        </div>
    );
}